import { HttpClient } from '../interceptor';

export class CarouselManagementApi{
    // 获取轮播图
    static getCarouselImageList = () => {
        return new Promise(resolve => {
            HttpClient.get('/api/imageInfoController/getImageInfo', {}).then(res => {
                if(res.data.status === 200){
                    resolve(res.data.content);
                }
            }).catch(err => console.log(err));
        })
    }

    // 新增轮播图
    static insertImage = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/imageInfoController/addImageInfo', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

    // 删除轮播图
    static deleteImage = (imageId) => {
        return new Promise(resolve => {
            HttpClient.post('/api/imageInfoController/deleteImageInfo', { imageId }).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

}